export class PropertyManagerDetailModel {
    public facilityId: number;
    public id: string;
    public name: string;
    public email: string;
    public phone: string;
}
